import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import { useDispatch, useSelector } from "react-redux";
import SearshEstabelecimento from "../../../../../utils/searchEstabelecimento";
import Paginacao from "../../../../../utils/paginacao";
import ListaSolicitacao from "../listaSolicitacao";
import { useNavigate, useSearchParams } from "react-router-dom";
import RegisterAccess from "../../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoExcel } from "../../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoPdf } from "../../../../exports/gerarelatoriopdf";
import { temPermissao } from "../../../../../utils/permissoes";
import TabelaLoading from "../../../../../load/tabelaLoading";

export default function DirectorGeralArea() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.account.user);
  const [tipo, setTipo] = useState('');
  const [status, setStatus] = useState(''); // novo estado para filtro de status
  const [provincia, setProvincia] = useState(''); // novo estado para filtro de status
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState("");
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  useEffect(() => {
    if ((user?.funcao === "Director Geral" || user?.funcao === "CNP") || temPermissao(user, ['licenciamentoEstabelecimentoDeferimento'])) {
    } else {
      dispatch({
        type: "alert",
        payload: { alert: "Acesso negado" },
      });
      navigate("/admin/menu");
    }

    setLoading(true);
    setEstabelecimentos("");
    api.get(`/estabelecimentos?page=${page}&status=Deferimento&perPage=${perPage}&tipoId=${tipo}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&sortBy=nome:${order}`)
      .then((response) => {
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [
          ...prevItems,
          ...response.data.estabelecimentos,
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [page, perPage, order, tipo, status, provincia, dispatch, user?.funcao, navigate, dataInicio, dataFim]);

  return (
    <>
      <RegisterAccess page={"area do director geral"} />

      <HeaderSession
        title="PROCESSOS ANÁLIZADOS PELA CHEFE DE DEPARTAMENTO"
        actions={true}
        handleExportExcel={() =>
          SolicitacoesLicenciamentoExcel(estabelecimentos)
        }
        handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      <SearshEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        placeholder={"Filtra por nome, número de entrada, data"}
        filtroStatus={false}
        tipo={tipo}
        provincia={provincia}
      />

      {estabelecimentos && (
        <>
          <ListaSolicitacao
            estabelecimentos={estabelecimentos}
            setEstabelecimentos={setEstabelecimentos}
            tipo={tipo}
            setTipo={setTipo}
            provincia={provincia}
            setProvincia={setProvincia}
            setDataInicio={setDataInicio}
            setDataFim={setDataFim}
            dataInicio={dataInicio}
            dataFim={dataFim}
          >
            <Paginacao
              configLista={configLista}
              lista={estabelecimentos}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
              setOrder={setOrder}
            />
          </ListaSolicitacao>
        </>
      )}

      {loading && <TabelaLoading />}
    </>
  );
}
